import { Component } from '@angular/core';

@Component({
  selector: 'app-direiros-reservados',
  templateUrl: './direiros-reservados.component.html',
  styleUrls: ['./direiros-reservados.component.scss']
})
export class DireirosReservadosComponent {

  protected readonly ano = new Date().getFullYear();
}
